/**
 * Recording entry point for tool handlers/commands.
 *
 * A migrated tool calls `recordCurrentStepOperation(toolId, params)` right after
 * it applies, so the operation joins the log for whatever step is active. Keeping
 * this out of the editor store avoids an import cycle (the workflow store already
 * imports the editor store).
 */
import useWorkflowStore from '../../../shared/stores/useWorkflowStore';
import { isCheckpointStep } from '../constants';
import useOperationLogStore from './operationLogStore';

/**
 * @param {string} toolId  Must match a key in the operation registry to be replayable.
 * @param {Record<string, unknown>} [params]
 * @param {string} [stepIdOverride]  Force the owning step (defaults to current step).
 * @param {{ durationMs?: number, vertexCount?: number, deviceVerticesPerMs?: number }} [metrics]
 * @returns {string | null} the step the operation was recorded against
 */
export function recordCurrentStepOperation(
  toolId,
  params = {},
  stepIdOverride = null,
  metrics = {},
) {
  const stepId = stepIdOverride ?? useWorkflowStore.getState().currentStep;
  if (!stepId || !isCheckpointStep(stepId)) return null;
  useOperationLogStore.getState().recordOperation(stepId, toolId, params, metrics);
  return stepId;
}
